let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iV5Fv")).then(() => parcelRequire('6RiYZ'));